// FetchVehicleDocModal.jsx
import React from 'react'
import { DocumentModal } from 'components'
import { utils } from 'helper';
import Image from '../../assets/img/Fetch_Container.png'

const FetchVehicleDocModal = (props) => {
    let {
        onRefresh,
        onUpdate,
        onContinue,
        isOpen,
        onClose = () => { },
        modalZIndex,
    } = props;

    const footer = (
        <div className="d-flex w-100 gap-2">
            <button
                className="btn btn-outline-secondary flex-fill"
                onClick={onUpdate}
            >
                Update
            </button>
            <button
                className="btn btn-primary flex-fill"
                onClick={onContinue}
            >
                Continue
            </button>
        </div>
    );

    return (
        <div>
            <DocumentModal
                isOpen={isOpen}
                onClose={(e) => onClose(e)}
                modalZIndex={modalZIndex}
                footer={footer}
                {...props}
            >
                <div className="addLr_body mt-2">
                    <div className="text-center py-3 px-3">
                        <div
                            className="mx-auto mb-3 d-flex align-items-center justify-content-center rounded-circle"
                            style={{
                                width: 56,
                                height: 56,
                                backgroundColor: '#e6f9f0',
                            }}
                        >
                            {/* <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="28"
                                height="28"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#28a745"
                                strokeWidth="2.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <polyline points="20 6 9 17 4 12" />
                            </svg> */}
                            <img src={Image} />
                        </div>

                        <h6 className="fw-bold mb-1">
                            {isOpen?.response?.vehicle_no ? isOpen?.response?.vehicle_no : ''} Added Successfully
                        </h6>

                        <p className={isOpen?.isFetch ? "text-success small mb-1" : "text-danger small mb-1"}>
                            {isOpen?.isFetch ? "Please Find Document Details" : "Document Not Fetched"}
                        </p>

                        {isOpen?.isFetch === false && <span
                            className="text-primary small"
                            style={{ cursor: 'pointer' }}
                            onClick={onRefresh}
                        >
                            Refresh
                        </span>}
                    </div>

                    <table className="table table-bordered table-sm mb-0">
                        <tbody>
                            {isOpen?.document?.map((items, index) => (
                                <tr key={index}>
                                    <td className=" small">{items.doc_type_id?.name ? items.doc_type_id?.name : items?.name}</td>
                                    {/* items.expiry_date ? "" : "___red_color  small" */}
                                    <td
                                        className=" small"
                                    >
                                        {items.expiry_date ? utils.getDate(items.expiry_date) : 'Not Fetched'}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </DocumentModal>
            <div className="offBack_drop"></div>
        </div>
    )
}

export default FetchVehicleDocModal